module.exports = __webpack_public_path__ + "img/video_card_image.b789aa49.png";